// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".custom-back-to-top{color:#000;font-size:16px;font-style:normal;font-weight:400;bottom:10px;position:fixed;right:15px;z-index:2000}@media (min-width:992px){.custom-back-to-top{display:inline-block;position:relative;right:unset;bottom:unset;z-index:unset}}body.page-with-drawer--experience .app-wrapper .custom-back-to-top,body.page-with-drawer--landing .app-wrapper .custom-back-to-top{bottom:95px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
